module.exports = __webpack_public_path__ + "static/media/development.f383b0a5.svg";